import Types from "../actions/types";
import { onSaveQueued, onCreatorIdSet } from "../actions";
import { ofType } from "redux-observable";
import { getOrganisationBaseUrl } from "frame";
import { mergeMap } from "rxjs/operators";
import { of } from "rxjs";
import { ADD_JOB_PATH, JOBS_PATH } from "../actions/types";
import { push } from "connected-react-router";
import { getCurrentTimestamp } from "utils";
import uuid from "uuid";
import { addQueueItem, sendRequested } from "features/queue";
import { setGlobalMessage } from "../actions";

const jobAddEffect = (action$, state$) =>
	action$.pipe(
		ofType(Types.JOBS_SAVE_CLICKED),
		mergeMap(() => {
			const profileId = state$.value.profile?.id;
			const isNew = state$.value.jobs.isNew;
			const currentJob = state$.value.jobs.currentJob;
			
			// Set creatorId for new jobs if not already set
			const creatorId = currentJob.creatorId || profileId || "";
			
			let url = `${getOrganisationBaseUrl(
				state$.value
			)}/job/createorupdate`;

			let body = {
				id: currentJob.id,
				title: currentJob.title,
				createdAt: currentJob.createdAt,
				type: currentJob.type,
				customerId: currentJob.customerId,
				siteId: currentJob.siteId,
				staffId: currentJob.staffId,
				notes: currentJob.notes,
				attachments: currentJob.attachments,
				latitude: state$.value.geolocation.latitude,
				longitude: state$.value.geolocation.longitude,
				timestamp: getCurrentTimestamp(),
				organisationId: state$.value.organisations.currentOrganisation,
				creatorId: creatorId,
				pinnedToSite: !!currentJob.pinnedToSite,
				pinnedToCustomer: !!currentJob.pinnedToCustomer,
				pinnedToStaff: !!currentJob.pinnedToStaff,
			};

			let path = JOBS_PATH;
			if (window.location.pathname !== ADD_JOB_PATH) {
				path = window.location.pathname;
			}

			let itemId = uuid.v4();

			const globalMessages = state$.value.jobs.globalMessage || [];

			// Update creatorId in state for optimistic update if it's a new job
			const actions = [];
			if (isNew && creatorId && !currentJob.creatorId) {
				actions.push(onCreatorIdSet(creatorId));
			}

			return of(
				...actions,
				addQueueItem({ id: itemId, url, body }),
				onSaveQueued(),
				// Add a per-job sync message so the navbar banner can reflect queued items
				setGlobalMessage([
					...globalMessages,
					[itemId, `Syncing ${currentJob.title}...`],
				]),
				sendRequested(),
				push(path)
			);
		})
	);

export default jobAddEffect;
